import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Alert,
  Box
} from '@mui/material';

export default function RejectionDialog({
  open,
  onClose,
  onReject,
  classification
}) {
  const [reason, setReason] = useState('');
  const [manuallyClassify, setManuallyClassify] = useState(false);
  const [error, setError] = useState('');

  const handleReject = () => {
    // Validation: minimum 20 characters
    if (reason.trim().length < 20) {
      setError('Rejection reason must be at least 20 characters');
      return;
    }

    // Call parent callback with rejection data
    onReject({
      classificationId: classification?.id,
      reason: reason.trim(),
      manuallyClassify
    });

    // Reset state
    setReason('');
    setManuallyClassify(false);
    setError('');
  };

  const handleCancel = () => {
    setReason('');
    setManuallyClassify(false);
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Reject Classification</DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 3 }}>
          This will reject the AI suggestion. Please explain why this classification is incorrect.
        </Alert>

        {classification && (
          <Box sx={{ mb: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
            <Box sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
              Transaction: {classification.transaction_description}
            </Box>
            <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', mt: 0.5 }}>
              AI Suggested: {classification.suggested_account_code} - {classification.suggested_account_name}
            </Box>
            <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', mt: 0.5 }}>
              Confidence: {classification.suggested_confidence_1}%
            </Box>
          </Box>
        )}

        <TextField
          label="Rejection Reason"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            setError('');
          }}
          multiline
          rows={4}
          fullWidth
          required
          error={!!error}
          helperText={error || `${reason.length}/20 characters minimum`}
          placeholder="Explain why this classification is incorrect. For example: 'AI suggested wrong brand - this is a Sand&Sky payout not YogaPaws' or 'Incorrect GL account - should be 5100 (Refunds) not 4000 (Revenue)'"
          sx={{ mb: 2 }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={manuallyClassify}
              onChange={(e) => setManuallyClassify(e.target.checked)}
            />
          }
          label="Manually classify this transaction now"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          onClick={handleReject}
          variant="contained"
          color="error"
          disabled={reason.trim().length < 20}
        >
          Reject Classification
        </Button>
      </DialogActions>
    </Dialog>
  );
}
